var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LiquidacionReportesPageLayout',{attrs:{"title":_vm.messages.DETALLADO_PAGE_TITLE}},[_c('LiquidacionDetalladoTab')],1)}
var staticRenderFns = []

export { render, staticRenderFns }